import { createSelector } from "reselect";
import { OfflineMap } from "../../types/offlineMaps.types";
import { OfflineMapsState } from "./offlineMaps.reducer";

export const getOfflineMapsMaps = (state: OfflineMapsState): OfflineMap[] => state.maps;
export const getOfflineMapsAmbientEnabled = (state: OfflineMapsState): boolean => state.ambientCacheEnabled;
export const getOfflineMapsTutorialShown = (state: OfflineMapsState): boolean => state.tutorialShown;
export const getOfflineMapsMap = (uuid: string) => createSelector(getOfflineMapsMaps, maps => maps.find(m => m.uuid === uuid));
